export const LEARN_MORE_URL_MAX_LENGTH = 255;

export const normalizeLearnMoreUrl = (learnMoreUrl) => {
	return (learnMoreUrl ?? '').trim();
};

// The validator's `url` rule only recognises a lower-case scheme, while HTTPS://host is a valid
// URL, so the scheme (and only the scheme) is lower-cased before validating.
export const lowerCaseUrlScheme = (url) => {
	return url.replace(/^https?:\/\//i, (scheme) => { return scheme.toLowerCase(); });
};
